/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ tool: NonNullable<unknown> }} Audit_Details_Uno_Tool_Approved_Spoken_DescInputs */



/**
* | output |
* | --- |
* | "Uno tool: {tool}, approved (spoken)" |
*
* @param {Audit_Details_Uno_Tool_Approved_Spoken_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_details_uno_tool_approved_spoken_desc = /** @type {((inputs: Audit_Details_Uno_Tool_Approved_Spoken_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Details_Uno_Tool_Approved_Spoken_DescInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Uno-Werkzeug: ${i?.tool}, freigegeben (mündlich)`)
	return /** @type {LocalizedString} */ (`Uno tool: ${i?.tool}, approved (spoken)`)
});